import { render } from "./GridParteneriDetalii.vue?vue&type=template&id=b4f861a4&scoped=true&ts=true"
import script from "./GridParteneriDetalii.vue?vue&type=script&lang=ts"
export * from "./GridParteneriDetalii.vue?vue&type=script&lang=ts"

import "./GridParteneriDetalii.vue?vue&type=style&index=0&id=b4f861a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f861a4"]])

export default __exports__